<div class="layout">
	<div class="appbar-container">
		<kpa-appbar
			(toggleSidenav)="toggleSidenav()"
			[isSideNavOpen]="isSideNavOpen"
			[isMobile]="isMobile"
			(languageChange)="onLanguageChange()"></kpa-appbar>
	</div>
	<div class="main-container">
		<div
			class="navigation-pane"
			[class.open]="isSideNavOpen">
			<kpa-sidenav
				[menuitems]="menuitems"
				[selectedId]="selectedId"
				(stateChange)="onStateChange($event)"></kpa-sidenav>
		</div>
		<div class="content-pane hidden-scrollbar">
			<kpa-switchlanguages
				[dialogOpened]="isSwitchDialogOpen"
				(dialogOpenedChange)="handleSwitchLanguage($event)"
				(closeDialog)="closeDialog()"></kpa-switchlanguages>
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
